import * as Yup from 'yup';

const convertToUnitTypeModalSchema = () => ({
  units: Yup.number().integer().min(1).required(),
  multiUnitProperty: Yup.string().required(),
});

export default convertToUnitTypeModalSchema;
